import { render, staticRenderFns } from "./DashboardCategoryViewer.vue?vue&type=template&id=31ba07ea"
import script from "./DashboardCategoryViewer.vue?vue&type=script&lang=js"
export * from "./DashboardCategoryViewer.vue?vue&type=script&lang=js"
import style0 from "./DashboardCategoryViewer.vue?vue&type=style&index=0&id=31ba07ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports